import { render, staticRenderFns } from "./DetailGroup.vue?vue&type=template&id=e5704a64&scoped=true"
import script from "./DetailGroup.vue?vue&type=script&lang=js"
export * from "./DetailGroup.vue?vue&type=script&lang=js"
import style0 from "./DetailGroup.vue?vue&type=style&index=0&id=e5704a64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5704a64",
  null
  
)

export default component.exports